import { useEffect } from 'react';

const PAGE_SCROLL_LOCKED_CLASS = 'page-scroll-locked';

let lockCount = 0;

const syncPageScrollLockClass = () => {
  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.classList.toggle(PAGE_SCROLL_LOCKED_CLASS, lockCount > 0);
};

export const usePageScrollLock = (isLocked: boolean): void => {
  useEffect(() => {
    if (!isLocked) {
      return;
    }

    lockCount += 1;
    syncPageScrollLockClass();

    return () => {
      lockCount -= 1;
      syncPageScrollLockClass();
    };
  }, [isLocked]);
};

export const usePageScrollLockWhileRendered = (): void => usePageScrollLock(true);
